import AddOns from './AddOns';
import ContactInfo from './ContactInfo';
import MealInfo from './MealInfo';
import OrgInfo from './OrgInfo/';
import PartnerSelection from './PartnerSelection';

export default [ContactInfo, OrgInfo, MealInfo, PartnerSelection, AddOns];
